import React from "react";
import { Youtube, ArrowUpRight } from "lucide-react";
import { Reveal, Kicker, Section } from "@/components/landing/kit";
import { YOUTUBE_CASE_STUDIES, YOUTUBE_CHANNEL } from "@/lib/site-data";

const ChannelCaseStudies = () => (
  <Section id="proof" className="py-24 sm:py-32">
    <Reveal className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <Kicker className="mb-5">Real case studies · straight from our channel</Kicker>
        <h2 className="text-balance font-heading text-4xl font-black leading-[0.98] tracking-tight text-[#0F1117] sm:text-6xl">
          Don&apos;t take our word for it. Watch the stores.
        </h2>
      </div>
      <a
        href={YOUTUBE_CHANNEL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="youtube-channel-link"
        className="inline-flex items-center gap-2 whitespace-nowrap font-heading text-sm font-bold uppercase tracking-wide text-[#2D5BFF] transition-colors hover:text-[#1E47E6]"
      >
        <Youtube className="h-5 w-5" />
        Watch more on YouTube
        <ArrowUpRight className="h-4 w-4" />
      </a>
    </Reveal>

    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      {YOUTUBE_CASE_STUDIES.map((v) => (
        <Reveal
          key={v.id}
          className="overflow-hidden rounded-3xl border border-[#E5E8F0] bg-white shadow-sm"
          data-testid={`case-video-${v.id}`}
        >
          <div className="relative aspect-video w-full">
            <iframe
              className="absolute inset-0 h-full w-full"
              src={`https://www.youtube-nocookie.com/embed/${v.id}`}
              title={v.title}
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div className="p-6">
            <h3 className="font-heading text-xl font-bold tracking-tight text-[#0F1117]">
              {v.title}
            </h3>
            <p className="mt-1 text-sm text-[#6B7385]">{v.meta}</p>
          </div>
        </Reveal>
      ))}
    </div>

    <p className="mt-10 text-center text-xs text-[#8A909E]">
      Individual results shown are not typical; your results will vary.
    </p>
  </Section>
);

export default ChannelCaseStudies;
